import { useContext, useState } from "react";

import { TodosContext } from "../store/todos-context";
import classes from "./NewTodo.module.css";

const NewTodo: React.FC = () => {
  const todosCtx = useContext(TodosContext);
  const [enteredTodo, setEnteredTodo] = useState<string>("");

  const submitHandler = (event: React.FormEvent) => {
    event.preventDefault();

    if (enteredTodo && enteredTodo.trim().length === 0) {
      // throw an error
      return;
    }

    //props.onAddTodo(enteredText);
    todosCtx.addTodo(enteredTodo!);

    setEnteredTodo("");
  };

  return (
    <form onSubmit={submitHandler} className={classes.form}>
      <label htmlFor="text">Enter Todo to add</label>
      <input
        type="text"
        id="text"
        onChange={(event) => setEnteredTodo(event.target.value)}
        value={enteredTodo}
      />
      <button>Add Todo</button>
    </form>
  );
};

export default NewTodo;
